goog.provide("shadow.js.shim.module$$mui$material$Paper");
goog.provide("module$shadow_js_shim_module$$mui$material$Paper");
shadow.js.shim.module$$mui$material$Paper = shadow.js.nativeProvides["@mui/material/Paper"] = shadow$bridge("@mui/material/Paper");
module$shadow_js_shim_module$$mui$material$Paper.default = shadow.js.shim.module$$mui$material$Paper;
